import { WalletVisitor } from './WalletVisitor';
import { SolanaWalletAdapter } from './SolanaWalletAdapter';
import { LocalWallet } from './LocalWallet';
import { GuestWallet } from './GuestWallet';
import { DelegatedWallet } from './DelegatedWallet';
import { WalletInterface } from './types';

export class WalletTypeDetector implements WalletVisitor {
  private _isGuestWallet: boolean = false;
  
  visitSolanaWallet(_wallet: SolanaWalletAdapter): void {
    this._isGuestWallet = false;
  }
  
  visitLocalWallet(_wallet: LocalWallet): void {
    this._isGuestWallet = false;
  }
  
  visitGuestWallet(_wallet: GuestWallet): void {
    this._isGuestWallet = true;
  }
  
  visitDelegatedWallet(_wallet: DelegatedWallet): void {
    this._isGuestWallet = false;
  }
  
  get isGuestWallet(): boolean {
    return this._isGuestWallet;
  }
  
  // Static utility method
  static isGuestWallet(wallet: WalletInterface | null): boolean {
    if (!wallet) return false;
    
    const detector = new WalletTypeDetector();
    wallet.accept(detector);
    return detector.isGuestWallet;
  }
} 